
import React from "react";
import { EntryCard } from "./EntryCard";
import { Database } from "@/integrations/supabase/types";

type Entry = Database["public"]["Tables"]["entries"]["Row"] & {
  creator_email?: string;
  last_editor_email?: string;
};

type EntryListProps = {
  entries: Entry[];
  currentUserId: string | undefined;
  toggleFavorite: (entry: Entry) => void;
  togglePinned: (entry: Entry) => void;
  copyShareLink: (entry: Entry) => void;
  stripHtmlTags: (html: string | null) => string;
  onRemoveSharedEntry?: (entryId: string) => void;
};

export const EntryList = ({ 
  entries,
  currentUserId,
  toggleFavorite,
  togglePinned,
  copyShareLink,
  stripHtmlTags,
  onRemoveSharedEntry
}: EntryListProps) => {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      {entries.map((entry) => (
        <EntryCard
          key={entry.id}
          entry={entry}
          toggleFavorite={toggleFavorite}
          togglePinned={togglePinned}
          copyShareLink={copyShareLink}
          stripHtmlTags={stripHtmlTags}
          currentUserId={currentUserId}
          onRemove={onRemoveSharedEntry}
        />
      ))}
    </div>
  );
};
